// Navegação por teclado nas barras de busca, global.
//
// enterAbrePrimeiro: Enter na barra de busca → abre/seleciona o PRIMEIRO resultado
// da lista filtrada exibida. Torna o sistema operável pelo teclado: digita, Enter,
// já entra no item — sem precisar do mouse.
//
// Uso típico (input que já existe na tela, sem mexer no layout):
//   <input value={q} onChange={...}
//          onKeyDown={enterAbrePrimeiro(listaFiltrada, item => abrir(item))} />
//
// Seguro por construção:
//  - lista vazia → Enter não faz nada (sem efeito colateral);
//  - preventDefault evita submit de form / recarregar página;
//  - o formNav global já ignora campos de busca, então não há disputa pelo Enter.

import type { KeyboardEvent } from 'react'

export function enterAbrePrimeiro<T>(
  itens: T[] | undefined | null,
  abrir: (primeiro: T) => void,
) {
  return (e: KeyboardEvent) => {
    if (e.key !== 'Enter' || e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return
    const lista = itens
    if (!lista || lista.length === 0) return
    e.preventDefault()
    abrir(lista[0])
  }
}

// navegarLista: navegação COMPLETA por teclado num dropdown de busca.
//  - ↓ / ↑ movem o item destacado (hi = índice atual; setHi atualiza);
//  - Enter seleciona o item destacado (não o 1º cego — respeita a navegação);
//  - Esc fecha (se onEscape for passado).
// O dropdown deve destacar visualmente o item de índice `hi` e resetar `hi` p/ 0
// quando o texto muda. Substitui o enterAbrePrimeiro onde há realce/setas.
// Seguro: lista vazia → Enter/setas não fazem nada.
export function navegarLista<T>(
  itens: T[] | undefined | null,
  hi: number,
  setHi: (n: number) => void,
  onSelect: (item: T) => void,
  onEscape?: () => void,
) {
  return (e: KeyboardEvent) => {
    const lista = itens || []
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setHi(lista.length ? Math.min(hi + 1, lista.length - 1) : 0)
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setHi(Math.max(hi - 1, 0))
    } else if (e.key === 'Enter') {
      if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey || !lista.length) return
      e.preventDefault()
      onSelect(lista[Math.min(Math.max(hi, 0), lista.length - 1)])
    } else if (e.key === 'Escape' && onEscape) {
      onEscape()
    }
  }
}
